var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalog text-center"},[_c('h1',[_vm._v("课程目录")]),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"stripe":"","header-cell-style":{
        'text-align': 'center',
        background: '#fd4a29',
        color: '#fff',
      },"border":""}},[_c('el-table-column',{attrs:{"prop":"section","label":"章节","align":"center","width":"100"}}),_c('el-table-column',{attrs:{"prop":"name","label":"课程名称","align":"center"}})],1),_c('hr')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }